export const dashboardData = [
  {
    key: "todayBookings",
    changeKey: "bookingChange",
    title: "Total Booking",
    prefix: "",
    text: "From previous period",
    bg_color: "bg-primary",
  },
  {
    key: "todayAmount",
    changeKey: "amountChange",
    title: "Total Amount",
    prefix: "₹",
    text: "New income",
    bg_color: "bg-info",
  },
  {
    key: "todayCustomers",
    changeKey: "customerChange",
    title: "Total Customer",
    prefix: "",
    text: "From previous period",
    bg_color: "bg-warning",
  },
  {
    key: "todayRevenue",
    changeKey: "revenueChange",
    title: "Total Revenue",
    prefix: "₹",
    text: "From previous period",
    bg_color: "bg-success",
  },
];
